import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { AppDownloadCTA } from "@faire/retailer-visitor-shared/components/Footer/AppDownloadCTA";
import { DESKTOP_AND_ABOVE_FOOTER_HORIZ_PADDING, MOBILE_FOOTER_HORIZ_PADDING, TABLET_FOOTER_HORIZ_PADDING } from "@faire/retailer-visitor-shared/components/Footer/consts";
import { FooterBottom } from "@faire/retailer-visitor-shared/components/Footer/FooterBottom";
import { LoggedOutAppDownloadCTA } from "@faire/retailer-visitor-shared/components/Footer/LoggedOutAppDownloadCTA";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { AccessibilityAnchor, AccessibilityLink } from "@faire/retailer-visitor-shared/lib/AccessibilityLink";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useIsSemDiscoverPage } from "@faire/retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { blogPage } from "@faire/retailer-visitor-shared/paths/index";
import { getSettingOpenWithFaireAvailableForCountry } from "@faire/retailer-visitor-shared/settings/getSettingOpenWithFaireAvailableForCountry";
import { useSettingOwFGrant } from "@faire/retailer-visitor-shared/settings/useSettingOwFGrant";
import { getRetailerToken, RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { SOCIAL } from "@faire/web--source/common/consts/SOCIAL";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Badge } from "@faire/web--source/slate/deprecated/Badge";
import { Column, Flex, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { trackHelpCenterFaireHomeFooterHelpCenterClick } from "@faire/web-api--source/events/helpCenter/click/faireHomeFooterHelpCenter";
import { trackLoggedOutRetailersHomePageFooterInsiderLabelClick } from "@faire/web-api--source/events/loggedOutRetailers/click/homePageFooterInsiderLabel";
import affiliates from "@faire/web-api--source/routes/affiliates";
import brands from "@faire/web-api--source/routes/brands";
import careers from "@faire/web-api--source/routes/careers";
import insiderMarketingPage from "@faire/web-api--source/routes/insider";
import faireMarkets from "@faire/web-api--source/routes/markets";
import posAbout from "@faire/web-api--source/routes/point-of-sale/about";
import support from "@faire/web-api--source/routes/support";
import supportRetailers from "@faire/web-api--source/routes/support/retailers";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
var FooterBase = function(_param) {
    var ref = _param.ref, props = _object_without_properties(_param, [
        "ref"
    ]);
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, _props_noTopBorder = props.noTopBorder, noTopBorder = _props_noTopBorder === void 0 ? false : _props_noTopBorder, _props_noTopMargin = props.noTopMargin, noTopMargin = _props_noTopMargin === void 0 ? false : _props_noTopMargin, _props_childFirst = props.childFirst, childFirst = _props_childFirst === void 0 ? false : _props_childFirst, children = props.children;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var retailerToken = getRetailerToken();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isSemDiscoverPage = useIsSemDiscoverPage();
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    var hasAccessToLoggedOutInsiderMarketingPage = useInsiderFeatureEligibility().hasAccessToLoggedOutInsiderMarketingPage;
    var isEligibleForOwFGrant = useSettingOwFGrant();
    var footerSections = [
        {
            title: strictLocalize({
                id: "2gPyd0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Company"
                    }
                ]
            }),
            links: [
                {
                    name: strictLocalize({
                        id: "g1AR2a",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "About us"
                            }
                        ]
                    }),
                    to: "/about",
                    target: undefined,
                    isExternal: false,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "8n7nzo",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Newsroom"
                            }
                        ]
                    }),
                    to: "https://news.faire.com",
                    target: undefined,
                    isExternal: true,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "yJ1ORH",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Careers"
                            }
                        ]
                    }),
                    to: careers(),
                    target: undefined,
                    isExternal: false,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "PvaPSn",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Affiliates"
                            }
                        ]
                    }),
                    to: affiliates(),
                    target: undefined,
                    isExternal: false,
                    shouldShow: true
                }
            ]
        },
        {
            title: strictLocalize({
                id: "nHqI97",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Explore"
                    }
                ]
            }),
            links: [
                {
                    name: strictLocalize({
                        id: "02wgPf",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Help center"
                            }
                        ]
                    }),
                    to: isLoggedInRetailer ? supportRetailers() : support(),
                    target: "_blank",
                    isExternal: false,
                    shouldShow: true,
                    peteEvent: function() {
                        return trackHelpCenterFaireHomeFooterHelpCenterClick(retailerToken, "");
                    }
                },
                {
                    name: strictLocalize({
                        id: "PVie/y",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Open with Faire"
                            }
                        ]
                    }),
                    to: "/open-with-faire",
                    target: "_blank",
                    isExternal: false,
                    shouldShow: getSettingOpenWithFaireAvailableForCountry(),
                    eventPath: "/open-with-faire/general-footer/click"
                },
                {
                    name: strictLocalize({
                        id: "MdjcZU",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Faire Markets"
                            }
                        ]
                    }),
                    to: faireMarkets(),
                    target: "_blank",
                    isExternal: false,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "MUa59n",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Sell on Faire"
                            }
                        ]
                    }),
                    to: brands(),
                    target: undefined,
                    isExternal: false,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "+mb53H",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Small Business Grant"
                            }
                        ]
                    }),
                    to: "/small-business-grant",
                    target: undefined,
                    isExternal: false,
                    shouldShow: isEligibleForOwFGrant
                },
                {
                    name: strictLocalize({
                        id: "rSKMj1",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Insider"
                            }
                        ]
                    }),
                    to: insiderMarketingPage(),
                    target: "_blank",
                    isExternal: false,
                    shouldShow: !isLoggedInRetailer && hasAccessToLoggedOutInsiderMarketingPage,
                    peteEvent: function() {
                        return trackLoggedOutRetailersHomePageFooterInsiderLabelClick();
                    }
                },
                {
                    name: strictLocalize({
                        id: "wQoOWp",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "POS integration"
                            }
                        ]
                    }),
                    to: posAbout(),
                    target: undefined,
                    isExternal: false,
                    shouldShow: true
                }
            ]
        },
        {
            title: strictLocalize({
                id: "zldxLE",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Connect"
                    }
                ]
            }),
            links: [
                {
                    name: strictLocalize({
                        id: "tv5FG3",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Blog"
                            }
                        ]
                    }),
                    to: "".concat(blogPage(locale), "/"),
                    target: "_blank",
                    isExternal: true,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "39PtLD",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Instagram"
                            }
                        ]
                    }),
                    to: SOCIAL.INSTAGRAM,
                    target: "_blank",
                    isExternal: true,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "EmpHyB",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Facebook"
                            }
                        ]
                    }),
                    to: SOCIAL.FACEBOOK,
                    target: "_blank",
                    isExternal: true,
                    shouldShow: true
                },
                {
                    name: strictLocalize({
                        id: "8ywLSf",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Twitter"
                            }
                        ]
                    }),
                    to: SOCIAL.TWITTER,
                    target: "_blank",
                    isExternal: true,
                    shouldShow: true
                }
            ]
        }
    ];
    var LoggedInOrLoggedOutAppDownloadCTA = isLoggedInRetailer && RetailerStore.get().showContextualAppDownloadCTAs ? AppDownloadCTA : LoggedOutAppDownloadCTA;
    if (isSemDiscoverPage) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(ZIndexContainer, {
        ref: ref,
        className: className,
        children: [
            noTopBorder ? null : /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(FooterContainer, {
                $noTopMargin: noTopMargin,
                children: /*#__PURE__*/ _jsxs(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(FooterSectionsWrapper, {
                            children: /*#__PURE__*/ _jsx(Content, {
                                children: footerSections.map(function(section, idx) {
                                    return /*#__PURE__*/ _jsx(FooterSection, {
                                        section: section,
                                        hideDivider: idx === 0
                                    }, section.title);
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Children, {
                            $childFirst: childFirst,
                            children: children ? children : /*#__PURE__*/ _jsx(LoggedInOrLoggedOutAppDownloadCTA, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(FooterBottom, {})
        ]
    });
};
export var Footer = observer(FooterBase);
var FooterSection = function(param) {
    var section = param.section, hideDivider = param.hideDivider;
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HorizontalSectionLine, {
                $hidden: hideDivider
            }),
            /*#__PURE__*/ _jsxs(Section, {
                children: [
                    /*#__PURE__*/ _jsx(SectionTitle, {
                        children: section.title
                    }),
                    /*#__PURE__*/ _jsx(SectionLinks, {
                        children: section.links.map(function(link) {
                            return /*#__PURE__*/ _jsx(SectionLink, {
                                link: link
                            }, link.name);
                        })
                    })
                ]
            })
        ]
    }, section.title);
};
var FooterSectionsWrapper = styled.div.withConfig({
    componentId: "sc-5fe454d7-0"
})([
    "width:100%;"
]);
var SectionLink = function(param) {
    var link = param.link;
    if (!link.shouldShow) {
        return null;
    }
    var handleLinkClick = function() {
        if (link.peteEvent) {
            link.peteEvent();
        }
        if (link.eventPath) {
            trackEventOnClick(link.eventPath);
        }
    };
    if (link.isExternal) {
        return /*#__PURE__*/ _jsx(SectionItem, {
            children: /*#__PURE__*/ _jsx(AccessibilityAnchor, {
                href: link.to,
                target: link.target,
                rel: "noopener noreferrer",
                onClick: handleLinkClick,
                children: /*#__PURE__*/ _jsx(LinkText, {
                    children: link.name
                })
            })
        }, link.name);
    }
    return /*#__PURE__*/ _jsx(SectionItem, {
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(AccessibilityLink, {
                    to: link.to,
                    target: link.target,
                    onClick: handleLinkClick,
                    children: /*#__PURE__*/ _jsx(LinkText, {
                        children: link.name
                    })
                }),
                link.isNew ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(NewBadge, {
                            content: "New",
                            backgroundColor: Core.surface.success
                        })
                    ]
                }) : null
            ]
        })
    }, link.name);
};
var ZIndexContainer = styled.div.withConfig({
    componentId: "sc-5fe454d7-1"
})([
    "position:relative;width:100%;background-color:",
    ";"
], Core.surface.inverse);
var FooterContainer = styled.footer.withConfig({
    componentId: "sc-5fe454d7-2"
})([
    "overflow:auto;display:flex;flex-direction:column;align-self:stretch;align-items:stretch;justify-content:flex-start;width:100%;max-width:1440px;padding:0 ",
    "px;margin:0 auto;",
    "{padding:0 ",
    "px;margin:",
    " auto 48px;}",
    "{padding:0 ",
    "px;}"
], MOBILE_FOOTER_HORIZ_PADDING, responsiveMediaQueries.tabletAndAbove, TABLET_FOOTER_HORIZ_PADDING, function(props) {
    return props.$noTopMargin ? "0" : "56px";
}, responsiveMediaQueries.desktopAndAbove, DESKTOP_AND_ABOVE_FOOTER_HORIZ_PADDING);
var ContentWrapper = styled(Flex).attrs({
    justify: {
        mobileAndAbove: "flex-start",
        tabletAndAbove: "space-between"
    },
    align: "flex-start",
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-5fe454d7-3"
})([
    ""
]);
var Content = styled.ul.withConfig({
    componentId: "sc-5fe454d7-4"
})([
    "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%;",
    "{margin:24px 0;flex-direction:row;width:auto;}"
], responsiveMediaQueries.tabletAndAbove);
var HorizontalSectionLine = styled(HorizontalLine).withConfig({
    componentId: "sc-5fe454d7-5"
})([
    "display:",
    ";",
    "{display:none;}"
], function(props) {
    return props.$hidden ? "none" : "block";
}, responsiveMediaQueries.tabletAndAbove);
var Section = styled.li.withConfig({
    componentId: "sc-5fe454d7-6"
})([
    "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;margin-right:30px;width:100%;padding:16px 0;",
    "{padding:0;margin-right:50px;}"
], responsiveMediaQueries.desktopAndAbove);
var SectionTitle = styled(Typography).attrs({
    variant: "paragraphSansMedium"
}).withConfig({
    componentId: "sc-5fe454d7-7"
})([
    "&&&{margin:0 0 6px;}"
]);
var LINK_MARGIN = 3;
var SectionLinks = styled.ul.withConfig({
    componentId: "sc-5fe454d7-8"
})([
    "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;margin:",
    "px 0;"
], -LINK_MARGIN);
var SectionItem = styled.li.withConfig({
    componentId: "sc-5fe454d7-9"
})([
    "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;margin:",
    "px 0;"
], LINK_MARGIN);
var LinkText = styled(Typography).withConfig({
    componentId: "sc-5fe454d7-10"
})([
    "white-space:nowrap;"
]);
var Children = styled(Column).withConfig({
    componentId: "sc-5fe454d7-11"
})([
    "align-self:stretch;order:",
    ";margin:0 ",
    "px;",
    "{margin:0 ",
    "px;}",
    "{margin:0 ",
    "px;}"
], function(props) {
    return props.$childFirst ? "-1" : "0";
}, -MOBILE_FOOTER_HORIZ_PADDING, responsiveMediaQueries.tablet, function(props) {
    return props.$childFirst ? 0 : -TABLET_FOOTER_HORIZ_PADDING;
}, responsiveMediaQueries.desktopAndAbove, function(props) {
    return props.$childFirst ? 0 : -DESKTOP_AND_ABOVE_FOOTER_HORIZ_PADDING;
});
var NewBadge = styled(Badge).withConfig({
    componentId: "sc-5fe454d7-12"
})([
    "width:38px;height:24px;"
]);
